/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Staatsexamen_Medizin_Pharmazie32Inputs */

const en__field_enum_tuda_staatsexamen_medizin_pharmazie32 = /** @type {(inputs: _Field_Enum_Tuda_Staatsexamen_Medizin_Pharmazie32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Medizin / Pharmazie`)
};

const de__field_enum_tuda_staatsexamen_medizin_pharmazie32 = /** @type {(inputs: _Field_Enum_Tuda_Staatsexamen_Medizin_Pharmazie32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Medizin / Pharmazie`)
};

/**
* | output |
* | --- |
* | "Staatsexamen Medizin / Pharmazie" |
*
* @param {_Field_Enum_Tuda_Staatsexamen_Medizin_Pharmazie32Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_staatsexamen_medizin_pharmazie32 = /** @type {((inputs?: _Field_Enum_Tuda_Staatsexamen_Medizin_Pharmazie32Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Staatsexamen_Medizin_Pharmazie32Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_staatsexamen_medizin_pharmazie32(inputs)
	return de__field_enum_tuda_staatsexamen_medizin_pharmazie32(inputs)
});
export { _field_enum_tuda_staatsexamen_medizin_pharmazie32 as "_field_enum_TUDA_STAATSEXAMEN_MEDIZIN_PHARMAZIE" }